import { Shield, ArrowLeft, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";
import { useCRM } from "../context/CRMContext";

export const CrmImpersonationBanner = () => {
  const { isImpersonating, currentCrm, exitImpersonation } = useCRM();

  if (!isImpersonating || !currentCrm) {
    return null;
  }

  return (
    <div className="w-full bg-amber-500/10 border-b border-amber-500/20 text-amber-900 dark:text-amber-200 px-4 py-2 flex items-center justify-between text-xs sm:text-sm font-medium z-40">
      <div className="flex items-center gap-2">
        <span className="flex h-2 w-2 rounded-full bg-amber-500 animate-pulse" />
        <Shield className="w-4 h-4 text-amber-600 dark:text-amber-400 shrink-0" />
        <span>
          Acesso de Superadministrador: Visualizando CRM{" "}
          <strong className="font-semibold text-foreground">
            {currentCrm.name}
          </strong>{" "}
          <span className="text-muted-foreground text-xs">
            ({currentCrm.slug})
          </span>
        </span>
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          asChild
          className="h-7 text-xs border-amber-500/30 hover:bg-amber-500/10"
        >
          <Link to="/admin/crms">
            <ExternalLink className="w-3 h-3 mr-1" />
            Painel Master
          </Link>
        </Button>
        <Button
          variant="default"
          size="sm"
          onClick={exitImpersonation}
          className="h-7 text-xs bg-amber-600 hover:bg-amber-700 text-white"
        >
          <ArrowLeft className="w-3 h-3 mr-1" />
          Sair deste CRM
        </Button>
      </div>
    </div>
  );
};
